import { http } from './http';
import type {
  CreateWorksiteRequest,
  PageResponse,
  WorksiteSmartBannerDto,
  WorksiteWorkspaceSummaryDto,
  WorksiteDetail,
  WorksiteFilter,
  WorksiteListSummaryDto,
  WorksiteStatus,
} from './types';

export const worksitesApi = {
  list(filter: WorksiteFilter = {}): Promise<PageResponse<WorksiteListSummaryDto>> {
    const params: Record<string, string | number | boolean> = {};
    if (filter.q) params.q = filter.q;
    if (filter.status) params.status = filter.status;
    if (filter.tag) params.tag = filter.tag;
    if (filter.assigneeUserId) params.assigneeUserId = filter.assigneeUserId;
    if (filter.health) params.health = filter.health;
    if (filter.hasOverdueMilestones === true) params.hasOverdueMilestones = true;
    if (filter.hasActivePresence === true) params.hasActivePresence = true;
    params.page = filter.page ?? 0;
    params.size = filter.size ?? 20;
    params.sort = filter.sort && filter.sort.length > 0 ? filter.sort : 'updatedAt,desc';
    return http.get<PageResponse<WorksiteListSummaryDto>>('/worksites', { params }).then((r) => r.data);
  },

  get(id: string): Promise<WorksiteDetail> {
    return http.get<WorksiteDetail>(`/worksites/${id}`).then(r => r.data);
  },

  create(data: CreateWorksiteRequest): Promise<{ id: string }> {
    return http.post<{ id: string }>('/worksites', data).then(r => r.data);
  },

  update(id: string, data: CreateWorksiteRequest): Promise<void> {
    return http.put(`/worksites/${id}`, data).then(() => undefined);
  },

  updateStatus(id: string, status: WorksiteStatus): Promise<void> {
    return http.patch(`/worksites/${id}/status`, { status }).then(() => undefined);
  },

  archive(id: string): Promise<void> {
    return http.delete(`/worksites/${id}`).then(() => undefined);
  },

  smartBanners(worksiteId: string): Promise<WorksiteSmartBannerDto[]> {
    return http.get<WorksiteSmartBannerDto[]>(`/worksites/${worksiteId}/smart-banners`).then((r) => r.data);
  },

  workspaceSummary(worksiteId: string): Promise<WorksiteWorkspaceSummaryDto> {
    return http.get<WorksiteWorkspaceSummaryDto>(`/worksites/${worksiteId}/workspace-summary`).then((r) => r.data);
  },
};
